import { Component, Input } from '@angular/core';

import { TwcBadgeType } from '@topcon/twc-angular';

import { JOB_STATUS_INCOMPLETE, JobStatus } from '@mirage-projects/cw-models';

/**
 * Component that shows a badge depending the supplied job state
 * How to use it:
 * Just add the component in the place you wan to set, and pass the job status
 *
 * @example
 *
 * <cw-status-badge [status]="job.status"></cw-status-badge>
 */
@Component({
    selector: 'cw-status-badge',
    templateUrl: 'status-badge.component.html',
    styleUrls: ['status-badge.component.scss'],
    standalone: false,
})
export class StatusBadgeComponent {
    /** Current status to set the badge */
    @Input() status: JobStatus = 'SUCCESS';

    private readonly NOT_COMPLETED_BADGE: JobStatus[] = [
        'CANCELLED',
        'CANCELLING',
        'RUNNING_WITH_ERRORS',
        'SUCCESS_WITH_ERRORS',
        ...JOB_STATUS_INCOMPLETE,
    ];
    private readonly UPLOAD_BADGE: JobStatus[] = ['UPLOADED', 'UPLOADING'];

    /**
     * Sets the status badge style
     * @param job job to update
     */
    getStatusBadgeClass(): string {
        if (JOB_STATUS_INCOMPLETE.includes(this.status)) {
            return 'badge-incomplete';
        }

        if (this.status === 'SELECTED') {
            return 'badge-selected';
        }

        return '';
    }

    /**
     * Sets the badge type for the current job status
     */
    getStatusBadgeType(): TwcBadgeType | undefined {
        if (this.status === 'SUCCESS') {
            return 'success';
        }

        if (this.NOT_COMPLETED_BADGE.includes(this.status)) {
            return 'warning';
        }

        if (this.UPLOAD_BADGE.includes(this.status)) {
            return 'info';
        }

        if (this.status === 'FAILURE') {
            return 'error';
        }

        return undefined;
    }
}
